import { connect } from "react-redux";
import Summary from "./summary";
import { onEdit, onDelete } from "../actions";
import { onEdit as onEditSite, onDelete as onDeleteSite, onSelectSite } from "features/sites/actions";
import { getCustomerById } from "../utils";

const mapStateToProps = (state) => ({
	customer: getCustomerById(state),
	organisationId:
		state.organisations?.currentOrganisation?.id ||
		state.organisations?.currentOrganisation ||
		"",
	role: state.profile.role,
	siteList: state.sites.pagination?.results,
});

const mapDispatchToProps = {
	onEdit,
	onDelete,
	onEditSite,
	onDeleteSite,
	onSelectSite,
};

export default connect(mapStateToProps, mapDispatchToProps)(Summary);
